import { Background } from '../assets/images';

const MuiCssBaseline = {
  styleOverrides: `
        ::-webkit-scrollbar {
           width: 5px;
        }
        ::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0,0,0,0.15); 
            border-radius: 5px;
        }
        ::-webkit-scrollbar-thumb {
            background: rgba(0,0,0,0.25); 
            border-radius: 5px;
        }
        ::-webkit-scrollbar-thumb:hover {
            background: rgba(0,0,0,0.4); 
        }
        * {
            margin: 0;
            box-sizing: border-box;
        }
        html {
            font-size: 62.5%;
            height: 100%;
        }
        body {
            height: 100%;
            background-image: url(${Background.default});
            background-size: cover;
            background-position: center;

        
        }
        #root {
            height: 100%;
        }
    `
};

export default MuiCssBaseline;
